import { useDispatch } from "react-redux";
import { open } from "..";
import { IsLoadingState } from "../types";

export const useLoad = () => {
  const dispatch = useDispatch();

  const load = (payload: IsLoadingState) => {
    setTimeout(() => {
      dispatch(open(payload));
    }, 0);
  };

  return { load };
};
